import { trans } from "@mongez/localization";
import { TabContentProps } from "../../../types";
import { ImpactMessages } from "./ImpactMessages";
import { PillarCard } from "./PillarCard";

/**
 * Our Pillars of Impact component
 * Displays the three main pillars with impact messages
 */
export function OurPillarsOfImpact({ data }: TabContentProps) {
  if (!data?.pillarsOfImpact) {
    return null;
  }

  return (
    <div className="container py-4 lg:py-6 xl:py-8">
      {/* Header */}
      <h2 className="my-8 text-2xl font-semibold tracking-[-0.03rem] text-marine sm:my-10 sm:text-3xl md:my-12 md:text-[36px] lg:my-8 lg:text-[32px] xl:my-10 xl:text-[38px] 2xl:my-12 2xl:text-[42px] 3xl:my-16 3xl:text-[42px]">
        {trans("pillarsTitle")}
      </h2>

      {/* Three Pillars Grid */}
      <div className="mb-12 grid grid-cols-1 gap-6 sm:mb-14 sm:gap-8 md:mb-16 lg:grid-cols-3 md:gap-8 lg:mb-10 lg:gap-5 xl:mb-14 xl:gap-7 2xl:mb-16 2xl:gap-8 3xl:mb-20">
        {data.pillarsOfImpact.map((pillar, index) => (
          <PillarCard
            key={index}
            title={trans(pillar.title)}
            description={trans(pillar.description)}
          />
        ))}
      </div>

      {/* Impact Messages */}
      <ImpactMessages />
    </div>
  );
}
